import Fuse from "fuse.js";
import { Endpoint } from "models/apiDocumentation/apiDocumentationModels";
import { apiDocsRouteSuffixes } from "utils/routeConstants";

const keys: (keyof Endpoint)[] = ["url", "summary", "description", "tags"];

export type SearchBarOption = {
  url: string;
  displayText: string;
  summary: string;
};

export const seeAllResultsPage = {
  url: apiDocsRouteSuffixes.searchResults,
  displayText: "See all search results",
  summary: "",
};

export const fuzzyApiFilter = (
  allOptions: Endpoint[],
  filterString: string,
  seeAllResultsOption: boolean = false
): SearchBarOption[] => {
  if (!filterString) {
    return allOptions.map((endpoint) => ({
      url: endpoint.url,
      displayText: endpoint.url,
      summary: endpoint.summary,
    }));
  }
  const config: Fuse.IFuseOptions<Endpoint> = {
    includeMatches: true, // This will allow for future highlighting of matches within the data (e.g. in bold in the Figma designs)
    threshold: 0.4, // Controls how lenient the fuzzy search is
    keys,
  };
  const fuse = new Fuse(allOptions, config);
  const results: Endpoint[] = fuse.search(filterString).map((r) => r.item);
  return [
    ...(seeAllResultsOption ? [seeAllResultsPage] : []),
    ...results.map((endpoint) => ({
      url: endpoint.url,
      displayText: endpoint.url,
      summary: endpoint.summary,
    })),
  ];
};
